import LoadingBackdrop from '@/components/Grid/LoadingBackdrop';
import UploadIcon from '@/components/Icons/UploadIcon';
import SearchInput from '@/components/SearchInput';
import { useAppDispatch } from '@/store/hooks';
import { setFilters } from '@/store/slices/firstPartyDataSlice';
import { Button } from '@mui/material';
import { GridToolbarContainer } from '@mui/x-data-grid-pro';
import PropTypes from 'prop-types';
import { useCallback, useState } from 'react';
import FilterPopover from './FilterPopover';

const ToolBar = ({ setQuickFilter, handleOpenNewFileModal, loading, clients, filters }) => {
  const dispatch = useAppDispatch();

  const [filterValue, setFilterValue] = useState('');
  const onInputChange = event => {
    const value = event.target.value;
    setFilterValue(value);
    setQuickFilter((value || '').trim().split(' ') || []);
  };

  const _setFilters = useCallback(
    newFilters => {
      dispatch(setFilters(newFilters));
    },
    [dispatch],
  );

  return (
    <>
      <GridToolbarContainer sx={{ padding: 0 }}>
        <div className='p-[20px] relative w-full'>
          <div className='flex justify-between'>
            <div className='table-controls flex gap-[10px]'>
              <SearchInput placeholder='Search..' value={filterValue} onChange={onInputChange} />
              <FilterPopover clients={clients} filters={filters} loadingClients={loading} setFilters={_setFilters} />
            </div>
            <Button
              className='pl-auto'
              sx={{ height: 40, width: 135 }}
              color='primary'
              variant='contained'
              onClick={handleOpenNewFileModal}
            >
              <UploadIcon color='#FFFFFF' />
              <div className='pl-1'>Upload File</div>
            </Button>
          </div>
        </div>
        {loading ? <LoadingBackdrop /> : null}
      </GridToolbarContainer>
    </>
  );
};

ToolBar.propTypes = {
  loading: PropTypes.bool,
  handleOpenNewFileModal: PropTypes.func,
  clients: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      name: PropTypes.string,
    }),
  ),
  filters: PropTypes.shape({
    search: PropTypes.string,
  }),
  setQuickFilter: PropTypes.func,
};

export default ToolBar;
